<template>
  <div class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-nowrap items-center" v-if="visible">
    <ul v-if="last" class="pagination">
      <!-- go to first page (0) -->
      <li>
        <a class="pagination__link" @click="goPage(0)">
          <ChevronsLeftIcon class="w-4 h-4" />
        </a>
      </li>

      <!-- go to previous page -->
      <li>
        <a class="pagination__link" @click="goPage('prev')">
          <ChevronLeftIcon class="w-4 h-4" />
        </a>
      </li>

      <!-- first number page -->
      <li>
        <a
          class="pagination__link"
          v-if="last >= getNumberPage('first')"
          :class="{ 'pagination__link--active': page === getNumberPage('first') }"
          @click="goPage(getNumberPage('first'))"
          >{{ getNumberPage("first") + 1 }}</a
        >
      </li>

      <!-- second number page -->
      <li>
        <a
          class="pagination__link"
          v-if="getNumberPage('first') !== getNumberPage('second') && last >= getNumberPage('second')"
          :class="{ 'pagination__link--active': page === getNumberPage('second') }"
          @click="goPage(getNumberPage('second'))"
          >{{ getNumberPage("second") + 1 }}</a
        >
      </li>

      <!-- third number page (if applicable) -->
      <li v-if="getNumberPage('second') !== getNumberPage('third') && last >= getNumberPage('third')">
        <a
          class="pagination__link"
          :class="{ 'pagination__link--active': page === getNumberPage('third') }"
          @click="goPage(getNumberPage('third'))"
          >{{ getNumberPage("third") + 1 }}</a
        >
      </li>

      <!-- go to next page -->
      <li>
        <a class="pagination__link" @click="goPage('next')">
          <ChevronRightIcon class="w-4 h-4" />
        </a>
      </li>

      <!-- go to last page (total_pages - 1) -->
      <li>
        <a class="pagination__link" @click="goPage(last)">
          <ChevronsRightIcon class="w-4 h-4" />
        </a>
      </li>
    </ul>

    <div class="ml-auto mr-5 text-gray-600">
      <slot name="summary">
        <!-- summary in 0-based; if you want to display human (1-based), use (page+1) / total_pages -->
        {{ page }} / {{ total_pages }} ({{ total }} total)
      </slot>
    </div>

    <select class="w-20 form-select box mt-3 sm:mt-0" :value="per_page" @change="onPerPageChange">
      <option v-for="s in displaySizes" :key="s" :value="s">
        {{ s }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "PaginationControls",
  props: {
    page: { type: Number, required: true },
    per_page: { type: Number, required: true },
    total_pages: { type: Number, required: true },
    total: { type: Number, default: 0 },
    sizes: { type: Array, default: () => [10, 25, 35, 50] },
    show: { type: Boolean, default: null },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:page", "update:per_page", "request"],
  computed: {
    visible() {
      return this.show === null ? this.total_pages > 0 : this.show;
    },
    last() {
      return Math.max(0, this.total_pages - 1);
    },
    displaySizes() {
      const filtered = this.sizes.filter((s) => s <= this.total);

      if (filtered.length === this.sizes.length) return filtered;

      // If at least one element was filtered, then add the total at the end
      if (!filtered.includes(this.total)) filtered.push(this.total);
      return filtered;
    },
  },
  methods: {
    goPage(param) {
      if (this.disabled) return;

      const last = this.last;
      let next = this.page;

      if (param === "prev") {
        next--;
      } else if (param === "next") {
        next++;
      } else {
        const temp = Number(param);
        if (!Number.isFinite(temp)) return;
        next = temp;
      }

      // clamp
      next = Math.min(Math.max(0, next), last);

      if (next !== this.page) {
        this.$emit("update:page", next);
        this.$emit("request");
      }
    },
    /**
     * Returns 0-based indexes to display: [page-1, page, page+1] with borders.
     */
    getNumberPage(which) {
      const p = this.page;
      const last = this.last;

      // 3-position 0-based window
      let first = p - 1;
      let second = p;
      let third = p + 1;

      const normalize = (n) => Math.min(Math.max(0, n), last);

      // clamp when there are few pages
      first = normalize(first);
      second = normalize(second);
      third = normalize(third);

      if (which === "first") return first;
      if (which === "second") return second;
      return third; // 'third'
    },
    onPerPageChange(e) {
      const val = Number(e.target.value);
      if (!Number.isNaN(val) && val !== this.per_page) {
        this.$emit("update:per_page", val);
        this.$emit("update:page", 0);
        this.$emit("request");
      }
    },
  },
};
</script>
